import { useEffect, useRef, useState } from 'react';
import socketService from '../services/socketService';

/**
 * useSocket Hook
 * Custom React hook for managing Socket.IO connection
 * Handles connection lifecycle and cleanup
 * 
 * @returns {Object} - Socket service instance and connection status
 */
const useSocket = () => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Connect socket on mount
    socketRef.current = socketService.connect();

    // Set initial connection status
    setIsConnected(socketService.isSocketConnected());

    // Listen for connection status changes
    const handleConnect = () => {
      console.log('✅ Socket connected in useSocket hook');
      setIsConnected(true);
    };

    const handleDisconnect = () => {
      console.log('❌ Socket disconnected in useSocket hook');
      setIsConnected(false);
    };

    socketService.on('connect', handleConnect);
    socketService.on('disconnect', handleDisconnect);

    // Cleanup on unmount
    return () => {
      socketService.off('connect', handleConnect);
      socketService.off('disconnect', handleDisconnect);
      // Don't disconnect here as socket is shared across components
      // Socket will be disconnected when user logs out or closes app
    };
  }, []);

  return {
    socket: socketService,
    isConnected,
  };
};

export default useSocket;
